import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import store from '../redux/store'
 

export const AppProvider = ({ children }) => {

  useEffect(() => {
    document.addEventListener('contextmenu', function(event) {
      event.preventDefault();
    });
  },[])
   
  return (
    <Provider store={store}>
      {children}
    </Provider>
  );
};

AppProvider.propTypes = { children: PropTypes.node };
 
export default AppProvider;
